import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { SystemApiService } from "@cv-invision/core";
import { GenericTableModel } from "../model/generic-table.model";

@Injectable()
export class GenericCrudService {

	public onChangeOptions$ = new Subject();
	public onCustomEvents$ = new Subject();
	public onRowClick$ = new Subject();

	constructor(protected httpClient: HttpClient, protected systemApiService: SystemApiService) {
	}

	/**
	 * method to get data from customUrl
	 * @param integrationParams
	 */
	getData(integrationParams: GenericTableModel): Observable<any> {
		const url = this.getUrlForData(integrationParams);

		let httpParams = new HttpParams();
		if(integrationParams.extraParams){
			const extraParams = integrationParams.extraParams;
			for(const key in extraParams){
				httpParams = httpParams.append(key, extraParams[key]);
			}
		}

		return this.httpClient.get(url, {params: httpParams});
	}

	/**
	 * method to get data from customUrl
	 * @param integrationParams
	 */
	public getCustomData(integrationParams: GenericTableModel, paramater: any): Observable<any> {
		let url = '';
		if(integrationParams.isCustomRecordData && integrationParams.urlGetRecordData){
			url = integrationParams.createCustomUrl(integrationParams.urlGetRecordData, paramater);
		}

		return this.httpClient.get(url);
	}


	/**
	 * Update the data in the custom Url provided
	 *
	 * @param integrationParams @see IntegrationsUrlParamsModel
	 * @param payload
	 * @returns
	 */
	saveData(integrationParams: GenericTableModel, payload: any[], paramater?: any): Observable<any> {
		let url = '';

		if(integrationParams.isCustomRecordData && integrationParams.urlGetRecordData){
			url = integrationParams.createCustomUrl(integrationParams.urlGetRecordData, paramater);
		} else {
			url = this.getUrlForData(integrationParams, payload);
		}

		return this.httpClient.put(url, payload);
	}

	/**
	 * Save data in the custom Url provided
	 * @param integrationParams
	 * @param payload
	 */
	savePostData(integrationParams: GenericTableModel, payload: any[]): Observable<any> {
		const url = this.getUrlForData(integrationParams);
		return this.httpClient.post(url, payload);
	}

	/**
	 *
	 * @param generalConfigParams
	 * @param payload
	 * @private
	 */
	private getUrlForData(generalConfigParams: GenericTableModel, payload?: any): string {
		let url = `${generalConfigParams.baseUrl}`;

		if(payload?.id){
			url = `${url}/${payload.id}`;
		}

		return url;
	}



	/**
	 * Delete model
	 * @param generalConfigParams
	 * @param payload
	 * @returns
	 */
	deleteModel(generalConfigParams: GenericTableModel, payload: any): Observable<any> {
		const url = this.getUrlForData(generalConfigParams, payload);
		return this.httpClient.delete(url);
	}

}
